<p>role-list-rate works!</p>
